import { useEffect, useState } from "react";
import { User } from "../Entities/User";
import AuthService from "../Service/auth.service";

const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const userToken = AuthService.getInstance().getAccessTokenFromLocalStorage();
  const fetchUser = async () => {
    const userData = await AuthService.getInstance().getCurrentUser();
    setUser(userData);
  };

  useEffect(() => {
    fetchUser();
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_IN,
      () => {
        fetchUser();
      }
    );
    AuthService.getInstance().subscribe(
      AuthService.EVENTS.USER_SIGNED_OUT,
      () => {
        setUser(null);
      }
    );
  }, [userToken]);

  return {
    user,
  };
};

export default useUser;
